'use strict';

exports.__esModule = true;
exports.default = PrefetchException;
/**
 * @constructor
 *
 * @param {Array} dispatchedActions — array of dispatched actions
 */
function PrefetchException(dispatchedActions) {
  this.type = 'prefetch';
  this.dispatchedActions = dispatchedActions;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/redux-preload/lib/prefetch/PrefetchException.js
// module id = 1218
// module chunks = 0